import { createStore } from '@aibees/shared/store';
import { EnrichmentMetadataStoreData as StoreData } from './types';

const useEnrichmentMetadataStore = createStore<StoreData>(
  'enrichment-metadata',
  (set) => ({
    metadata: undefined,
    setMetadata: (metadata) => set({ metadata }),
  })
);

export default useEnrichmentMetadataStore;
